import { attr } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Column = ApplicationRecord.extend({
  static: {
    jsonapiType: 'columns',
  },
  attrs: {
    name: attr(),
    columnType: attr(),
    category: attr(),
    defaultPlaceholder: attr(),
    templateId: attr()
  },
})

export default Column
